import * as React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { ConstructionDetails } from '../presentation/pages/client/ConstructionDetails';
import { PageDetails } from '../presentation/pages/client/ConstructionDetails/PageDetails';
import { HomeClient } from '../presentation/pages/client/home/HomeClient';
import { Teste } from '../presentation/pages/client/Teste';
import { DetailedPayables } from '../presentation/pages/client/ConstructionDetails/payables/DetailedPayables';

export default function ClientRoutes() {
  return (
    <Routes>
      <Route path="/client" element={<HomeClient />} />
      <Route
        path="/constructions-details/:id"
        element={<ConstructionDetails />}
      />
      <Route
        path="/constructions-details/:id/:slug"
        element={<PageDetails />}
      />
      <Route path="/detailed-payable/:id" element={<DetailedPayables />} />
      <Route path="/testee-switch" element={<Teste />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}
